/** biome-ignore-all assist/source/useSortedAttributes: <more readable> */

import { lazyImport } from "@resamare/ui";
import { Navigate, Route, Routes } from "react-router-dom";
import DefaultLayout from "@/components/Layout/DefaultLayout";

const { UnavailabilitiesPage } = lazyImport(() => import("../pages"), "UnavailabilitiesPage");
const { UnavailabilitiesCreatePage } = lazyImport(
    () => import("../pages"),
    "UnavailabilitiesCreatePage",
);
const { UnavailabilitiesUpdatePage } = lazyImport(
    () => import("../pages"),
    "UnavailabilitiesUpdatePage",
);

export function UnavailabilitiesRoutes() {
    return (
        <Routes>
            <Route element={<DefaultLayout />}>
                <Route path="/" element={<UnavailabilitiesPage />} />
                <Route path="/create" element={<UnavailabilitiesCreatePage />} />
                <Route path="/:id/update" element={<UnavailabilitiesUpdatePage />} />
                <Route path="*" element={<Navigate to="." />} />
            </Route>
        </Routes>
    );
}
